import { BannerCarousel } from 'components/Common/Common'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function Home() {
    return (
        <>
            <section
                className='client position-relative py-4 px-2 min-vh-100'
                style={{ background: "#3DA0AA0D" }}
            >
        <BannerCarousel/>

                {/* <Container fluid>
                    <Row className="justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
                        <Col xs="12" className="d-flex flex-column align-items-center text-center gap-3">
                            <div
                                style={{
                                    width: 72,
                                    height: 72,
                                    borderRadius: "50%",
                                    background: "#3DA0AA1A",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <svg
                                    width="32"
                                    height="32"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#3DA0AA"
                                    strokeWidth="1.8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path d="M3 9.5L12 4l9 5.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z" />
                                    <path d="M9 21V12h6v9" />
                                </svg>
                            </div>

                            <h5 className="fw-semibold mb-0" style={{ color: "#1F2937" }}>
                                No School Selected
                            </h5>

                            <p className="mb-0" style={{ color: "#6B7280", fontSize: "0.9rem", maxWidth: 320 }}>
                                Please select a school from the menu to view its reports and data.
                            </p>

                        </Col>
                    </Row>
                </Container> */}
            </section>
        </>
    )
}

export default Home